import { render, staticRenderFns } from "./AdministradorReportes.vue?vue&type=template&id=dba4d3b6"
import script from "./AdministradorReportes.vue?vue&type=script&lang=js"
export * from "./AdministradorReportes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports